
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.25 0a9.25 9.25 0 10.001 18.501A9.25 9.25 0 009.25 0zM2.027 9.25A7.224 7.224 0 019.25 2.027 7.224 7.224 0 112.027 9.25zM9.25 4.345a1.15 1.15 0 00-.84.371c-.22.236-.34.55-.34.876 0 .326.12.641.34.876.22.236.521.372.84.372.32 0 .622-.136.841-.372.22-.235.34-.55.34-.876 0-.325-.12-.64-.34-.876a1.15 1.15 0 00-.84-.371zM8.785 7.67a.411.411 0 00-.405.416v5.653a.41.41 0 00.405.416h.93c.24 0 .406-.203.406-.416V8.086a.411.411 0 00-.405-.416h-.931z","clip-rule":"evenodd"}})])
          )
        }
      }
    